import { useSearchParams } from "react-router-dom";
import PartnerOnboardingComponent from "./PartnerOnboardingComponent";
import PartnerTestMappingComponent from "./PartnerTestMappingComponent";

const LabPartnerCreationComponent = () => {
  const [params, _setParams] = useSearchParams();
  const page_step = params.get("page_step");

  return <div>{page_step === "ONBOARDING" ? <PartnerOnboardingComponent /> : <PartnerTestMappingComponent />}</div>;
};

export default LabPartnerCreationComponent;
